// extracted by mini-css-extract-plugin
export default {"title":"title___qqROa","line1":"line1___B80UV","line2":"line2___S8xwX"};